export enum StatusNewsFeed {
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
  ALL = "ALL",
  ARCHIVED = "ARCHIVED"
}
